import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Spinner } from "@/components/common";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Devices from "@/pages/Devices";
import DeviceDetail from "@/pages/DeviceDetail";
import Alerts from "@/pages/Alerts";
import Tickets from "@/pages/Tickets";
import TicketDetailPage from "@/pages/TicketDetailPage";
import Scripts from "@/pages/Scripts";
import Admin from "@/pages/Admin";
import AuditLog from "@/pages/AuditLog";
import Reports from "@/pages/Reports";
import Patches from "@/pages/Patches";
import Software from "@/pages/Software";
import Automation from "@/pages/Automation";
import NetworkDiscovery from "@/pages/NetworkDiscovery";
import Monitors from "@/pages/Monitors";
import Assets from "@/pages/Assets";
import People from "@/pages/People";
import PersonDetail from "@/pages/PersonDetail";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Integrations from "@/pages/Integrations";
import Portal from "@/pages/Portal";
import Placeholder from "@/pages/Placeholder";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center" style={{ background: "#0B0E14" }}><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

const isCustomerUser = (user) => user && user.role !== "mimoit_admin" && user.all_customers === false;

function AppRoutes() {
  const { user } = useAuth();
  if (isCustomerUser(user)) {
    return (
      <Routes>
        <Route path="/login" element={<Navigate to="/portal" replace />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/customers" element={<Protected><Customers /></Protected>} />
      <Route path="/customers/:id" element={<Protected><CustomerDetail /></Protected>} />
      <Route path="/devices" element={<Protected><Devices /></Protected>} />
      <Route path="/devices/:id" element={<Protected><DeviceDetail /></Protected>} />
      <Route path="/alerts" element={<Protected><Alerts /></Protected>} />
      <Route path="/tickets" element={<Protected><Tickets /></Protected>} />
      <Route path="/tickets/:id" element={<Protected><TicketDetailPage /></Protected>} />
      <Route path="/scripts" element={<Protected><Scripts /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="/patches" element={<Protected><Patches /></Protected>} />
      <Route path="/automation" element={<Protected><Automation /></Protected>} />
      <Route path="/software" element={<Protected><Software /></Protected>} />
      <Route path="/network-discovery" element={<Protected><NetworkDiscovery /></Protected>} />
      <Route path="/monitors" element={<Protected><Monitors /></Protected>} />
      <Route path="/assets" element={<Protected><Assets /></Protected>} />
      <Route path="/people" element={<Protected><People /></Protected>} />
      <Route path="/people/:id" element={<Protected><PersonDetail /></Protected>} />
      <Route path="/knowledge-base" element={<Protected><KnowledgeBase /></Protected>} />
      <Route path="/integrations" element={<Protected><Integrations /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#121824", border: "1px solid #1E293B", color: "#e2e8f0" } }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
